

<section>    
    <div class="example-button-row">  
          
      <button mat-raised-button color="primary" (click)="openDialog()">Add Teacher</button>     
    
      
    </div>

    <div class="container">
      <div style="margin-top: 10px;">
        <div class="example-header">
          <mat-form-field>
            <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
          </mat-form-field>
        </div>
        <!-- <button mat-raised-button color="primary" (click)="exportArrayToExcel()">Export as Excel</button> -->
        <div class="example-container mat-elevation-z8">
          

          <table  id="ExampleMaterialTable" mat-table [dataSource]="dataSource" matSort>
        
            <!-- ID Column -->
            <ng-container matColumnDef="id">
              <mat-header-cell *matHeaderCellDef mat-sort-header> ID </mat-header-cell>
              <mat-cell *matCellDef="let row"> {{row.id}} </mat-cell>
            </ng-container>
        
            <ng-container matColumnDef="Image">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Image </mat-header-cell>
              <mat-cell *matCellDef="let element"> <img [src]="element.Image" width="40px" height="40px" /> </mat-cell>
            </ng-container>

            <!-- Progress Column -->
            <ng-container matColumnDef="TeacherName">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
              <mat-cell *matCellDef="let row"> {{row.TeacherName}} </mat-cell>
            </ng-container>
        
            <!-- Name Column -->
            <ng-container matColumnDef="TeacherAge">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Age </mat-header-cell>
              <mat-cell *matCellDef="let row"> {{row.TeacherAge}} </mat-cell>
            </ng-container>
        
            <!-- Color Column -->
            <ng-container matColumnDef="TeacherAddress">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Address </mat-header-cell>
              <mat-cell *matCellDef="let row" > {{row.TeacherAddress}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="mobile">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Mobile </mat-header-cell>
              <mat-cell *matCellDef="let row" > {{row.mobile}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Qualification">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Qualification </mat-header-cell>
              <mat-cell *matCellDef="let row" > {{row.Qualification}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="DOJ">
              <mat-header-cell *matHeaderCellDef mat-sort-header> DOJ </mat-header-cell>
              <mat-cell *matCellDef="let row" > {{row.DOJ}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Experience">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Experience </mat-header-cell>
              <mat-cell *matCellDef="let row" > {{row.Experience}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Gender">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Gender </mat-header-cell>
              <mat-cell *matCellDef="let row" > {{row.Gender}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="DOB">
              <mat-header-cell *matHeaderCellDef mat-sort-header> DOB </mat-header-cell>
              <mat-cell *matCellDef="let row" > {{row.DOB}} </mat-cell>
            </ng-container>



            

            
           

            <ng-container matColumnDef="Action">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Action </mat-header-cell>
              <mat-cell *matCellDef="let row" > 
              <button mat-icon-button color="primary" (click)="editStudent(row)">
              <mat-icon>
                edit
              </mat-icon>
              </button>  
              <button mat-icon-button color="warn" (click)="deleteStudent(row)">
                <mat-icon>
                  delete
                </mat-icon>
                </button>  
              </mat-cell>
            </ng-container>
        
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;">
            </mat-row>
          </table>
        
          <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
        </div>
        
      </div>
    </div>
  </section>
